import(/* webpackMode: "eager", webpackExports: ["Companies"] */ "/workspace/src/components/moleculer/events/suzuka2024/companies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Top"] */ "/workspace/src/components/moleculer/events/suzuka2024/top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/workspace/src/components/moleculer/wrapper.tsx");
